import { render, staticRenderFns } from "./Breadcrumb.vue?vue&type=template&id=4e254c71&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumb.vue?vue&type=style&index=0&id=4e254c71&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e254c71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e254c71')) {
      api.createRecord('4e254c71', component.options)
    } else {
      api.reload('4e254c71', component.options)
    }
    module.hot.accept("./Breadcrumb.vue?vue&type=template&id=4e254c71&scoped=true", function () {
      api.rerender('4e254c71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/partials/Breadcrumb.vue"
export default component.exports